import { commerce } from "../data/commerce";
import type { PlanId } from "../types/landing";
export function isPlanPurchasable(id: PlanId): boolean {
  const cfg = commerce.plans[id];
  return Boolean(cfg.price.trim() && cfg.checkoutUrl.trim());
}
export function planPriceLabel(id: PlanId): string {
  const price = commerce.plans[id].price.trim();
  return price || "Precio a confirmar";
}
export function planOriginalPriceLabel(id: PlanId): string | null {
  return commerce.plans[id].originalPrice.trim() || null;
}
export function deliveryText(): string {
  const { channel, timeframe } = commerce.delivery;
  if (!channel.trim()) {
    return "El canal y el plazo de entrega se informarán antes de habilitar la compra. Vas a recibir únicamente los archivos incluidos en el plan que elijas.";
  }
  const time = timeframe.trim() ? ` ${timeframe.trim()}` : "";
  return `Después de completar la compra, accedés a los archivos de tu plan por ${channel.trim()}${time}.`;
}
export function refundText(): string {
  return (
    commerce.refundPolicy.trim() ||
    "La política de devolución se publicará antes de habilitar la compra."
  );
}
export function popularityBadge(id: PlanId): string | null {
  const { mostPurchased, mostRecommendedByBuyers } = commerce.popularity;
  if (mostPurchased.enabled && mostPurchased.planId === id) return "Más elegido";
  if (mostRecommendedByBuyers.enabled && mostRecommendedByBuyers.planId === id)
    return "Más recomendado por compradores";
  return null;
}
